<template>
  <div class="w-full flex flex-col presentation-card">
    <div class="flex flex-row justify-between items-center gap-2">
      <div class="flex flex-row items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <g clip-path="url(#clip0_presentation_card)">
            <path
              d="M14.6 3.5h-2.9c0-.7-.6-1.3-1.3-1.3H5.6c-.7 0-1.3.6-1.3 1.3H1.4c-.4 0-.8.3-.8.8v9.2c0 .4.3.7.7.7h13.3c.4 0 .7-.3.7-.7V4.3c.1-.5-.3-.8-.7-.8zM5.6 3.5h4.8v.7H5.6v-.7zm9 9.7h-13V4.9h2.7v.7h7.6v-.7h2.7v8.3z"
              fill="#4F4F4F"
            />
            <path d="M8 6.4l-2.5 4.4h5L8 6.4z" fill="#4F4F4F" />
          </g>
          <defs>
            <clipPath id="clip0_presentation_card">
              <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
            </clipPath>
          </defs>
        </svg>
        <h4 class="nxp-review-title">Apresentação</h4>
      </div>
    </div>
    <hr class="custom-hr my-2 mb-4" />

    <!-- Carta -->
    <section class="presentation-section">
      <header class="presentation-section-header">
        <h5 class="presentation-section-title">Carta de Apresentação</h5>
        <button
          class="presentation-section-action"
          type="button"
          @click="$router.push({ name: 'presentation-letter' })"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
            <path
              d="M4.54 15.5h.93l8.2-8.2-.93-.93L4.54 14.57V15.5zm-1.08 1.08v-2.47L13.82 3.73c.11-.11.23-.19.36-.24.13-.05.27-.07.41-.07.14 0 .28.02.4.07.13.04.25.12.37.24l.93.93c.12.12.2.24.25.37.05.13.07.26.07.4 0 .15-.03.29-.07.42-.05.13-.13.26-.24.37L5.92 16.58H3.46zm9.73-9.73l-.45-.46.93.93-.48-.47z"
              fill="#4F4F4F"
            />
          </svg>
          {{ hasLetter ? 'Editar' : 'Adicionar' }}
        </button>
      </header>
      <div v-if="hasLetter" class="presentation-section-body">
        <p class="presentation-letter-text">{{ talent.description }}</p>
      </div>
      <div v-else class="presentation-section-empty">
        Você ainda não preencheu sua carta de apresentação profissional.
      </div>
    </section>

    <hr class="custom-hr my-4" />

    <!-- Áudio -->
    <section class="presentation-section">
      <header class="presentation-section-header">
        <h5 class="presentation-section-title">Áudio de Apresentação</h5>
        <div class="presentation-section-actions-group">
          <button
            v-if="audio"
            class="presentation-section-link-danger"
            type="button"
            :disabled="audioBusy"
            @click="handleDeleteAudio"
          >
            Remover
          </button>
          <button
            class="presentation-section-action"
            type="button"
            @click="audioModalActive = true"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
              <path
                d="M4.54 15.5h.93l8.2-8.2-.93-.93L4.54 14.57V15.5zm-1.08 1.08v-2.47L13.82 3.73c.11-.11.23-.19.36-.24.13-.05.27-.07.41-.07.14 0 .28.02.4.07.13.04.25.12.37.24l.93.93c.12.12.2.24.25.37.05.13.07.26.07.4 0 .15-.03.29-.07.42-.05.13-.13.26-.24.37L5.92 16.58H3.46zm9.73-9.73l-.45-.46.93.93-.48-.47z"
                fill="#4F4F4F"
              />
            </svg>
            {{ audio ? 'Regravar' : 'Gravar' }}
          </button>
        </div>
      </header>
      <div v-if="audio" class="presentation-section-body">
        <audio :src="audio.url" controls class="presentation-audio-player"></audio>
        <details v-if="audio.has_transcription" class="presentation-audio-transcription">
          <summary>Ver transcrição automática</summary>
          <p>{{ audio.content_text }}</p>
        </details>
        <p v-else class="presentation-audio-pending">
          Transcrição em processamento. Atualize a página em alguns instantes.
        </p>
      </div>
      <div v-else class="presentation-section-empty">
        Grave um áudio curto (até 2 minutos) se apresentando.
      </div>
    </section>

    <hr class="custom-hr my-4" />

    <!-- Vídeo -->
    <section class="presentation-section">
      <header class="presentation-section-header">
        <h5 class="presentation-section-title">Vídeo de Apresentação</h5>
        <div class="presentation-section-actions-group">
          <button
            v-if="video"
            class="presentation-section-link-danger"
            type="button"
            :disabled="videoBusy"
            @click="handleDeleteVideo"
          >
            Remover
          </button>
          <button
            class="presentation-section-action"
            type="button"
            @click="videoModalActive = true"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
              <path
                d="M4.54 15.5h.93l8.2-8.2-.93-.93L4.54 14.57V15.5zm-1.08 1.08v-2.47L13.82 3.73c.11-.11.23-.19.36-.24.13-.05.27-.07.41-.07.14 0 .28.02.4.07.13.04.25.12.37.24l.93.93c.12.12.2.24.25.37.05.13.07.26.07.4 0 .15-.03.29-.07.42-.05.13-.13.26-.24.37L5.92 16.58H3.46zm9.73-9.73l-.45-.46.93.93-.48-.47z"
                fill="#4F4F4F"
              />
            </svg>
            {{ video ? 'Trocar vídeo' : 'Adicionar' }}
          </button>
        </div>
      </header>
      <div v-if="video" class="presentation-section-body">
        <div class="presentation-video-wrapper">
          <iframe
            :src="video.embed_url"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            frameborder="0"
            referrerpolicy="strict-origin-when-cross-origin"
          ></iframe>
        </div>
      </div>
      <div v-else class="presentation-section-empty">
        Compartilhe um vídeo do YouTube se apresentando para a empresa.
      </div>
    </section>

    <AudioPresentationModal
      :active.sync="audioModalActive"
      :has-existing="!!audio"
      @saved="reloadPresentation"
    />

    <VideoPresentationModal
      :active.sync="videoModalActive"
      :existing="video"
      @saved="reloadPresentation"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AudioPresentationModal from './presentation/AudioPresentationModal.vue';
import VideoPresentationModal from './presentation/VideoPresentationModal.vue';

export default {
  name: 'PresentationDetailCard',
  components: {
    AudioPresentationModal,
    VideoPresentationModal,
  },
  data: () => ({
    audioModalActive: false,
    videoModalActive: false,
    audioBusy: false,
    videoBusy: false,
  }),
  computed: {
    ...mapState('talent', ['talent']),
    ...mapState('presentation', ['audio', 'video']),
    hasLetter() {
      return !!(this.talent && this.talent.description && String(this.talent.description).trim() !== '');
    },
  },
  methods: {
    reloadPresentation() {
      this.$store.dispatch('presentation/fetch');
    },
    async handleDeleteAudio() {
      if (this.audioBusy) return;
      const ok = window.confirm('Tem certeza que deseja remover o áudio de apresentação?');
      if (!ok) return;
      this.audioBusy = true;
      try {
        await this.$store.dispatch('presentation/deleteAudio');
        this.$vs.notify({
          title: 'Áudio removido',
          iconPack: 'feather',
          icon: 'icon-check-circle',
          color: 'success',
        });
      } catch (error) {
        this.$vs.notify({
          title: 'Falha ao remover',
          text: 'Tente novamente em alguns instantes.',
          iconPack: 'feather',
          icon: 'icon-x-circle',
          color: 'danger',
        });
      } finally {
        this.audioBusy = false;
      }
    },
    async handleDeleteVideo() {
      if (this.videoBusy) return;
      const ok = window.confirm('Tem certeza que deseja remover o vídeo de apresentação?');
      if (!ok) return;
      this.videoBusy = true;
      try {
        await this.$store.dispatch('presentation/deleteVideo');
        this.$vs.notify({
          title: 'Vídeo removido',
          iconPack: 'feather',
          icon: 'icon-check-circle',
          color: 'success',
        });
      } catch (error) {
        this.$vs.notify({
          title: 'Falha ao remover',
          text: 'Tente novamente em alguns instantes.',
          iconPack: 'feather',
          icon: 'icon-x-circle',
          color: 'danger',
        });
      } finally {
        this.videoBusy = false;
      }
    },
  },
};
</script>

<style lang="scss">
.presentation-card {
  hr {
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    border: none;
  }
}

.presentation-section {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  &-title {
    margin: 0;
    font-family: Roboto, sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }

  &-actions-group {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &-action {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: transparent;
    border: none;
    color: #4f4f4f;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    padding: 0;

    &:hover {
      text-decoration: underline;
    }
  }

  &-link-danger {
    background: transparent;
    border: none;
    color: #de2348;
    font-family: Roboto, sans-serif;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    padding: 0;
    text-decoration: underline;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  &-body {
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &-empty {
    padding: 16px;
    border-radius: 8px;
    background: #fafafa;
    border: 1px dashed #d4d4d4;
    color: #696969;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    line-height: 1.5;
  }
}

.presentation-letter-text {
  margin: 0;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #4f4f4f;
  white-space: pre-wrap;
}

.presentation-audio-player {
  width: 100%;
  max-width: 480px;
}

.presentation-audio-transcription {
  margin-top: 4px;
  border-radius: 8px;
  border: 0.5px solid #ecebeb;
  background: #fafafa;

  summary {
    padding: 10px 14px;
    cursor: pointer;
    font-family: Roboto, sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: #4f4f4f;
  }

  p {
    margin: 0;
    padding: 0 14px 14px;
    font-family: Roboto, sans-serif;
    font-size: 13px;
    line-height: 1.5;
    color: #696969;
    white-space: pre-wrap;
  }
}

.presentation-audio-pending {
  margin: 0;
  font-size: 12px;
  color: #af6c00;
}

.presentation-video-wrapper {
  position: relative;
  width: 100%;
  max-width: 560px;
  aspect-ratio: 16 / 9;
  border-radius: 12px;
  overflow: hidden;
  background: #000;

  iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
